import { Command } from '@ckeditor/ckeditor5-core';

export default class RecorderStyleCommand extends Command {
    constructor( editor, styles ) {
        super( editor );

        // Estilos por defecto para cada tipo
        this._defaultStyles = {
            recorderBlock: false,
            recorderInline: false
        };

        // Mapeo de estilos disponibles
        this._styles = new Map(
            styles.map( style => {
                if ( style.isDefault ) {
                    for ( const modelElementName of style.modelElements ) {
                        this._defaultStyles[ modelElementName ] = style.name;
                    }
                }
                return [ style.name, style ];
            } )
        );
    }

    /**
     * @inheritDoc
     */
    refresh() {
        const editor = this.editor;
        const recorderUtils = editor.plugins.get( 'RecorderUtils' );
        const element = recorderUtils.getClosestSelectedRecorderElement( editor.model.document.selection );

        this.isEnabled = !!element;

        if ( !this.isEnabled ) {
            this.value = false;
        } else if ( element.hasAttribute( 'recorderStyle' ) ) {
            this.value = element.getAttribute( 'recorderStyle' );
        } else {
            this.value = this._defaultStyles[ element.name ];
        }
    }

    /**
     * Ejecuta el cambio de estilo
     */
    execute( options = {} ) {
        const editor = this.editor;
        const model = editor.model;
        const recorderUtils = editor.plugins.get( 'RecorderUtils' );

        model.change( writer => {
            const requestedStyle = options.value;
            let recorderElement = recorderUtils.getClosestSelectedRecorderElement( model.document.selection );

            // Si el estilo solicitado requiere conversión (block ↔ inline)
            if ( requestedStyle && this.shouldConvertRecorderType( requestedStyle, recorderElement ) ) {
                this.editor.execute(
                    recorderUtils.isBlockRecorder( recorderElement )
                        ? 'recorderTypeInline'
                        : 'recorderTypeBlock'
                );

                recorderElement = recorderUtils.getClosestSelectedRecorderElement( model.document.selection );
            }

            // Aplica o elimina estilo
            if ( !requestedStyle || this._styles.get( requestedStyle ).isDefault ) {
                writer.removeAttribute( 'recorderStyle', recorderElement );
            } else {
                writer.setAttribute( 'recorderStyle', requestedStyle, recorderElement );
            }
        } );
    }

    /**
     * Verifica si el estilo requiere convertir el tipo (block ↔ inline)
     */
    shouldConvertRecorderType( requestedStyle, recorderElement ) {
        const supportedTypes = this._styles.get( requestedStyle ).modelElements;
        return !supportedTypes.includes( recorderElement.name );
    }
}
